module.exports = __webpack_public_path__ + "img/logo.f373e5c8.png";